import { FormlyFieldConfig } from '@ngx-formly/core';
import { AgreementsFormOptions } from './agreements-form-options.interface';

export function getRecipientList(
    options: Partial<AgreementsFormOptions>,
    envelopeId: string,
    customFieldClass: string): FormlyFieldConfig[] {
    return [
        {
        fieldGroupClassName: 'row',
        fieldGroup: [
            {
                type: 'recipient-list',
                className: customFieldClass,
                props: {
                    envelopeId,
                    onReorder: options.onRecipientsReorder,
                    onLoad: options.onRecipientsLoad,
                },
            },
        ],
        },
    ]
}
